import account from './account';
import activity from './activity';
import APISettings from './api-settings';
import billing from './billing';
import companies from './companies';
import configurations from './configurations';
import customerGroup from './customer-group';
import customers from './customers';
import explore from './explore';
import help from './help';
import home from './home';
import onboarding from './onboarding';
import partnerPortal from './partner-portal';
import partners from './partners';
import platform from './platform';
import sections from './sections';
import shippingMethods from './shipping-methods';
import storefrontOptions from './storefront-options';
import storefrontWidgets from './storefront-widgets';
import synclog from './synclog';
import themes from './themes';

export default {
  activity,
  billing,
  companies,
  sections,
  customers,
  customer_group: customerGroup,
  explore,
  home,
  synclog,
  account,
  shipping_methods: shippingMethods,
  onboarding,
  partner_portal: partnerPortal,
  api_settings: APISettings,
  configurations,
  storefront_options: storefrontOptions,
  storefront_widgets: storefrontWidgets,
  themes,
  platform,
  partners,
  help,
};
